import { render, staticRenderFns } from "./NewEditSeriePage.vue?vue&type=template&id=54d4968f&scoped=true"
import script from "./NewEditSeriePage.vue?vue&type=script&lang=js"
export * from "./NewEditSeriePage.vue?vue&type=script&lang=js"
import style0 from "./NewEditSeriePage.vue?vue&type=style&index=0&id=54d4968f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d4968f",
  null
  
)

export default component.exports